import apiService from "@/services/apiService";

const NotificationService = {
  fetchNotifications: async (params = {}) => {
    const response = await apiService.get('/notifications', { params });
    return response.data;
  },

  markAsRead: async (id) => {
    const response = await apiService.patch(`/notifications/${id}/mark_as_read`);
    return response.data;
  },

  markAllAsRead: async () => {
    const response = await apiService.patch('/notifications/mark_all_as_read');
    return response.data;
  },
};

export default NotificationService;
